import { graphql, Link, useStaticQuery } from 'gatsby';
import React, { ReactElement } from 'react';
import Text from '../../../../type/text';
import './style.css';

// The left side navigation for all of the /support pages.
// Add categories to the /src/content/support-categories file
// to have them show up in the nav.
export default function SupportNav(): ReactElement {
  const data = useStaticQuery(graphql`
    query MyQuery {
      allStrapiSupportCategory(sort: { priority: ASC }) {
        nodes {
          slug
          name
        }
      }
    }
  `);

  return (
    <nav
      className="support-nav flex flex-col pt-20"
      aria-label="Support category navigation">
      <div className="support-nav__container sticky">
        {data.allStrapiSupportCategory.nodes.map(({ name, slug }) => {
          return (
            <Text level="semibold">
              <Link
                key={slug}
                to={`/support/${slug}/`}
                activeClassName="support-nav--active"
                partiallyActive>
                {name}
              </Link>
            </Text>
          );
        })}

        <Text level="semibold">
          <Link to="/support/privacy/" activeClassName="support-nav--active">
            Privacy
          </Link>
        </Text>

        <Text level="semibold">
          <Link to="/support/contact-us/" activeClassName="support-nav--active">
            Contact Us
          </Link>
        </Text>
      </div>
    </nav>
  );
}
